export default {
	termsAndConditions: {
		lastUpdate: '最後更新時間：2024 年 6 月 10 日',
		content: `
		<p>下面的條款很重要，因為：</p>
		<ul>
			<li>他們在 {siteName} 中確立了自己的法律權利。</li>
			<li>解釋您在使用 {siteName} 時授予我們的權利。</li>
			<li>
				它們描述了每個人在使用 {siteName} 時必須遵守的規則。
			</li>
		</ul>
		<p>
			請仔細閱讀這些條款以及我們的 {privacyPolicyLink} 和任何其他條款
			這些條款中提到的文件。
		</p>
		<p>讓我們開始吧...</p>
		<h3>1。 {siteNameUpper} 的簡介與資料。</h3>
		<p>
			網站{websiteLink}（以下簡稱「網站」）歸本公司所有
			{siteName} S.L（以下簡稱「{siteName}」），一家公司
			根據西班牙立法成立，地址位於 Avenida de
			Cerdanyola, n° 75, 1°, Sant Cugat del Vallès (巴塞隆納)，CIF 編號持有者
			B-56.768.260 並在巴塞隆納商業登記處註冊登記
			49065，Folio 0033，表 B-606324，第一次註冊。
		</p>
		<p>
			{siteName} 為您提供網站，以便您可以訪問
			更了解我們，了解我們提供的服務，如果您願意，您可以聯繫
			並在適當的情況下與我們簽訂合約。
		</p>
		<h3>2。使用條款的目的和適用範圍</h3>
		<p>
			這些使用條件與 {privacyPolicyLink} 和
			{cookiesPolicyLink}，規範網站所使用的法律框架
			{網站連結}。這些使用條件將在網站上提供給您
			英文版，以便您隨時查閱、存檔或列印
			無論你什麼時候想要。
		</p>
		<p>
			了解任何有關 {siteName} 治療的問題。
			有關您的個人數據，請造訪我們的 {privacyPolicyLink} 和 {cookiesPolicyLink}。
			這兩項政策也將以英文版本提供給您，以便您可以
			隨時查閱、存檔或列印。
			{siteName} 在網站上使用第三方 cookie。了解更多
			關於網路 {websiteLink} 上使用的 cookie 類型、其目的以及使用方式
			設定您的瀏覽器，以防您不希望我們使用這些 cookie，
			請造訪我們的{cookiesPolicyLink}。
		</p>
		<p>
			這些使用條件以及 {privacyPolicyLink} 和 
			{cookiesPolicyLink}已依現行規定制定
			適用的法規，其中包括關於服務的第 34/2002 號法律
			資訊社會與電子商務以及法規 (EU) 2016/679
			歐洲議會和理事會於 2016 年 4 月 27 日就
			在處理個人資訊方面保護自然人
			資料以及這些資料的自由流通以及指令 95/46 / CE
			被廢除。
		</p>
		<h3>3。造訪網站並接受</h3>
		<p>
			除與網站費用相關的部分外，造訪本網站是免費的
			透過互聯網提供的電信網路連接
			您已簽約的訪問提供者。您可以自由瀏覽本網站
			並根據需要多次訪問它。要造訪和瀏覽本網站，
			您不需要註冊，除非您想租用服務。
		</p>
		<p>
			使用該網站即表明您是該網站的使用者的條件
			（以下簡稱「使用者」）並暗示您完全且無保留地接受
			這些使用條件以及 {privacyPolicyLink} 和 {cookiesPolicyLink}
			網站的。此外，您同意不使用本服務進行非法活動
			目的。
		</p>
		<p>
			透過造訪並瀏覽本網站，您聲明您的
			您有責任確保您已達到法定年齡並且擁有必要的法律權利
			有能力存取並使用本網站，同時聲明您完全同意
			無保留地理解並接受這些使用條件。
		</p>
		<p>
			另一方面，我們通知您，出於法律原因，我們將存檔
			正式採購的電子文件。您可以訪問
			您可以隨時透過以下網址索取這些文件：{supportLink}。
		</p>
		<h3>4。網站的使用條件</h3>
		<p>
			使用者同意根據這些使用條件使用本網站，
			現行立法和誠信。因此，用戶將回應 {siteName}。
			 並在任何第三方之前就因以下原因造成的損害和損失負責：
			違反這些條件、立法和誠信的使用
			由網站使用者。
		</p>
		<h3>5。服務描述</h3>
		<p>
			透過該服務，{siteName} 允許訂閱該服務
			進行影像編輯。
		</p>
		<p>
			{siteName} 與買方之間簽訂合約所使用的語言
			將得出原籍國的結論。
			線上服務購買流程如下：
		</p>
		<ol>
			<li>您必須使用使用者名稱和密碼在網站上註冊。</li>
			<li>
				註冊時，用戶必須選擇其中一種付款計劃
				可以在“價格”部分找到，並將根據以下情況獲得學分：
				選定的計劃。每個積分將允許您編輯一張圖像。
			</li>
			<li>
				購買服務後，用戶將獲得管理權限
				他們會在其中找到：
				<ul>
					<li>
						包含已處理的所有圖像清單的部分，
						可以根據需要多次編輯並將其下載到您的
						裝置.
					</li>
					<li>
						計劃和付款部分用於查閱發票和取消
						訂閱。
					</li>
					<li>「我的帳戶」的一個部分，用於更改帳戶偏好設定。</li>
				</ul>
			</li>
		</ol>
		<p>
			購買服務後，將由
			最多在 24 小時內向您擁有的地址發送電子郵件
			表明的。它將指示該服務、如何取消訂閱、其
			金額、適用稅金、付款方式和適用條款以及
			狀況。
		</p>
		<h4>5.1 訂閱</h4>
		<p>
			服務訂閱根據所選計劃的不同而有所不同，並將
			自動續約相同期限直至終止。
			除非您取消訂閱，否則您授權我們加載
			您的付款方式中對應的年度訂閱費用。
		</p>
		<p>
			您可以隨時取消對服務的訂閱，並且您將
			繼續訪問它，直到您的年度計費期結束。到
			在法律允許的範圍內，付款不可退還，我們不提供
			部分年度訂閱期的退款或積分。
		</p>
		<h3>6。價格和稅收</h3>
		<p>
			{siteName} 上提供的產品價格以歐元表示
			(€) 或購買所在國家的貨幣，價值
			購買時有效的附加稅 (VAT) 根據商品價格徵收
			產品。
		</p>
		<p>
			在任何情況下，該操作都可以免除或不繳納增值稅，具體取決於
			您的居住國或您的行為條件。為此原因，
			在某些情況下，訂單的最終價格可能會根據
			如圖所示。
			免徵增值稅主體的購買將透過以下方式表明這一點：
			透過電子郵件將增值稅/NIF 號碼發送至 {supportLink}，而不是記錄
			購買時含上述稅金。
		</p>
		<h3>7。付款方式</h3>
		<p>
			購買服務的線上付款可以透過信用卡或金融卡進行。
			從這個意義上說，{siteName} 告知信用卡和金融卡持有者：
			在線商店中的交易是透過安全支付進行的
			網關，採用SSL技術確保資料傳輸的安全。
		</p>
		<h3>8。撤銷權和退款權</h3>
		<h4>8.1。撤銷權</h4>
		<p>
			鑑於我們在線服務中銷售的產品類型，數位軟體
			QR 格式，根據以下規定，撤回權將不適用
			11 月 16 日第 1/2007 號皇家立法令第 103 條，字母 m)
			《消費者保護普通法》的修訂案文和
			用戶和其他補充法律獲得批准。
		</p>
		<h4>8.2。退款</h4>
		<p>
			無論用戶選擇何種計劃，用戶支付的金額以及
			在法律允許的範圍內，將不予退款。
		</p>
		<p>
			合約服務不得轉讓或轉讓給其他用戶
			服務。
		</p>
		<p>
			在任何情況下，用戶都可以使用合約服務直至合約結束。
			合約期限。
		</p>
		<h3>9。要約的有效性</h3>
		<p>
			本服務所提供的服務及其價格將適用於
			當它們在透過此顯示的服務目錄中時進行購買
			網站。
		</p>
		<p>
			無論如何，{siteName} 保留對其進行修改的權利
			認為服務合適，能夠更新產品與服務
			取決於市場。
		</p>
		<p>
			{siteName} 保留更改價格的權利，恕不另行通知。我們
			通知您，儘管對價格進行了更新
			服務，它們可能包含錯誤。我們將及時糾正任何錯誤
			出現，但它們對服務不具約束力。
		</p>
		<h3>10。安全</h3>
		<p>
			如上所述，整個購買過程以及傳輸
			您的個人資料和支付系統的資訊是在安全頁面上進行的，並且
			透過 SSL 協定以加密方式。
		</p>
		<p>
			我們依照現行規定保證服務的安全性
			技術知識。但是，{siteName} 無法保證完整的
			服務的未來安全。無論如何，我們承諾糾正並
			實施適當的糾正措施以糾正可能的安全問題
			盡快突破。
		</p>
		<p>
			您同意立即透過電子郵件 {supportLink} 通知 {siteName}
			任何可能導致冒充使用者身分的情況。
		</p>
		<h3>11。修改和無效</h3>
		<p>
			我們將來也可能更新服務的條款和條件
			作為服務本身的特徵和功能。
		</p>
		<p>
			我們將透過發布通知的方式告知您條款和條件的變更
			在我們網站的顯著位置和/或透過電子郵件。
		</p>
		<p>
			如果聲明了這些條款和條件中包含的任何條款，則完全或
			部分、無效或無效，只會影響該條款或該部分
			其中無效或無效。條款和條件將持續有效
			具有此類規定的其他所有事物，或其受影響的部分，
			沒有被放置。
		</p>
		<h3>12。合約產生的索賠和訴訟</h3>
		<p>
			本服務盡可能受西班牙法律管轄。
			為了簡化透過民事訴訟解決索賠的過程
			降低成本，我們不排除將自己提交給
			商會仲裁院衡平法仲裁
			行業。從這個意義上說，根據適用的法規，
			 {siteName} 告知歐洲線上爭議解決方案的存在
			促進此類糾紛庭外解決的平台
			消費者和網路服務之間也在網路上簽訂合約
			提供者。該平台可透過以下網站存取：
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13。智慧財產權和工業產權</h3>
		<p>
			本網站及其內容受以下應用程式的保護
			現行國家知識產權和/或工業產權法規，如
			以及適用於此類領域的國際公約的應用
			很重要。 {siteName} 是所有網站的所有者或已獲得正式許可
			網站及其內容的知識產權和工業產權。
		</p>
		<p>
			任何形式的複製、散佈、公共傳播、改造、
			提供任何其他剝削行為，無論是否
			用於本網站或其內容的商業目的，未經事先許可
			{siteName} 明確同意。明確禁止刪除
			將 {siteName} 的資料識別為知識分子的擁有者，並且
			本網站或其內容的工業產權。
		</p>
		<p>
			{siteName} 保留所有智慧財產權和工業產權
			對本網站及其內容，也保留行使任何法律權利
			相應的行動，以停止、防止或起訴任何
			非法使用本網站或其內容。在任何情況下以及在沒有情況下
			使用者或第三方造訪本網站或使用本網站的情況
			各方構成或暗示 {siteName} 的任何類型的轉讓
			本網站或其內容的知識產權或工業產權。
			在任何情況下，{siteName} 都不會要求停止使用
			網站或其非法內容或違反這些條件的內容可能會被
			理解為 {siteName} 對此類使用的默許或棄權
			採取任何與之相對應的法律行動。
		</p>
		<h3>14。責任與保證</h3>
		<p>
			使用者必須依照以下規定使用本網站及其內容
			這些使用條件、現行立法和誠信的規定。任何
			違反這些一般條件使用本網站或其內容，
			法律或善意明確禁止，不論所述使用是否已
			是否有經濟目的。
			使用者將對 {siteName} 造成的任何損害或傷害負責
			 或直接或間接從任何使用中獲得的第三方
			使用者對網站或其內容的使用違反了這些規定
			條件、法律、道德、公共秩序或誠信。
		</p>
		<p>
			為了讓使用者可以存取網站及其內容，{siteName}
			 需要第三方提供的服務。它可能是
			儘管{siteName}努力保持網站可用
			並且可供用戶訪問，其可用性可能會被暫停、中斷或
			因 {siteName} 之外的原因而取消。這就是為什麼{siteName}
			不保證在存取過程中不會出現中斷或錯誤
			網站或其內容，也不更新或始終顯示
			他們的最新版本。因此，{siteName} 拒絕任何
			因以下原因可能對使用者或第三方造成的損害負責
			暫停、中斷、缺乏連續性、網路中斷的結果
			或網站斷開連線。
		</p>
		<p>
			在任何情況下，{siteName} 均不承擔任何責任
			由於不可歸咎於 {siteName} 的原因而對使用者造成的損害或損失
			 例如，例如但不限於自然的
			災難、不可抗力或極端緊急狀況、病毒、有害
			元件、瀏覽器故障、網路斷線、電腦入侵或
			第三方攻擊。
		</p>
		<h3>15。連結</h3>
		<p>
			網站、平台、論壇、聊天、部落格或外部社交網絡
			連結或指向本網站的連結必須明確告知他們沒有
			{siteName} 的授權或監督以及所述連結或
			連結並不意味著、假設或暗示 {siteName} 之間存在任何類型的關聯
			 以及網站、平台、論壇、聊天、部落格或外部
			連結或連結到本網站的社交網路。
		</p>
		<p>
			在任何情況下，任何指向本網站的連結都必須指向
			點選URL直接進入網站首頁或首頁
			覆蓋主頁或開始頁面的整個螢幕的網站的
			網站，以便連結是絕對和完整的，無需使用
			框架、框架或超連結。 {siteName} 在任何情況下都不回應
			並在任何情況下與相關的內容、資訊或數據
			網站、其內容或網站、平台中包含的任何其他事項，
			連結或連結到的論壇、聊天、部落格或第三方社交網絡
			網站。
		</p>
		<p>
			明確禁止從網站連結或連結到本網站，
			違反法律、道德的平台、論壇、聊天、部落格或社交網絡
			和良好的風俗習慣，特別是那些有色情、不正當、非法或
			侵犯人權的內容。
		</p>
		<p>
			另一方面，本網站可能包含第三方網站的鏈接，
			平台、論壇、聊天、部落格或社交網路。 {siteName} 沒有
			有人力和/或技術手段來了解或控制訊息，並且
			出現在第三方網站上的內容。因此，在任何情況下，{siteName} 都不會
			 對連結網站的內容負責，並且不承擔任何責任
			可以說連結被認為是對內容的有效了解的情況
			他們連結到的網站。
		</p>
		<h3>16。資料保護</h3>
		<p>
			根據其 {privacyPolicyLink} 中的規定，{siteName} 承諾使用用戶
			數據，尊重其機密性並依照
			治療的目的，以及履行其挽救治療的義務。
			並採取一切措施避免更改、遺失、處理或未經授權
			根據現行法律的規定進行訪問
			個人資料的保護。
		</p>
		<p>
			該網站採用適當的保護措施並使用行業標準
			技術以提高安全性、完整性、完整性、準確性和
			保護其收集的個人數據，並已建立
			採取合理的預防措施來保護該資訊免於可能的遺失或
			濫用。定期審查其資料保護和安全規則
			並在必要時進行改進，並努力確保只有經過授權的
			人們可以存取用戶提供的資訊。
		</p>
		<p>
			了解有關{siteName}進行的管理和處理的更多信息
			 關於您的數據，請閱讀我們的 {privacyPolicyLink} 和 {cookiesPolicyLink}。
		</p>
		<h3>17。持續時間和修改</h3>
		<p>
			只要它們暴露於
			用戶，以便一旦全部或部分修改或更新，
			這些條件將不再有效，成為新的使用條件
			那些繼續規範網站使用的人。
		</p>
		<p>
			{siteName} 保留審查、修改或更新這些內容的權利
			隨時使用的條件。如果這些條件有任何變化
			出於任何原因使用，{siteName} 將在主頁上通知用戶
			有關上述情況的網絡，以便他們及時了解並可以諮詢
			目前使用條件的修訂、修改或更新
			您的滿意。
		</p>
		<h3>18。一般</h3>
		<p>
			在任何情況下都不得導致您無法行使權利
			{siteName} 被理解為放棄它們。
		</p>
		<p>
			這些條件中包含的標題僅是指示性的或
			提供信息，因此不會影響、限定或擴大解釋
			其中。
		</p>
		<p>
			如果這些條件中包含的任何條款被
			由司法機構宣告全部或部分無效、濫用或不可執行
			或行政機構，所述聲明將單獨影響該條款
			有問題，視為不存在且沒有聲明無效、濫用或
			在任何情況下都不適用於其餘部分
			的條件，就會存在。
		</p>
		<p>
			這些使用條件以及 {privacyPolicyLink} 和 {cookiesPolicyLink}
			始終受西班牙現行法規管轄。
		</p>
		<h3>19。客戶服務</h3>
		<p>
			對於任何澄清、事件或索賠，您可以透過以下方式聯絡我們：<br />
			電子郵件：{supportLink}<br />
			郵寄地址：Av. Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, 巴塞隆納, 西班牙。
		</p>`
	},
	privacyPolicy: {
		lastUpdate: '最後更新時間：2024 年 6 月 10 日',
		content: `
			<h3>1。責任方及描述</h3>
			<h5>1.1。負責</h5>
			<p>負責處理本網站的人員是Remove Background S.L（以下簡稱「Remove Background」） 
			或服務），地址為 Av. Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, 巴塞隆納, 西班牙。</p>
			<p>NIF：B56768260<br>電子郵件：{supportLink}</p>

			<h5>1.2。說明</h5>
			<p>接受Remove Background的隱私權政策（以下簡稱「隱私權政策」），是必要條件 
				用於使用我們的網站和提供服務（以下簡稱「服務」）。
				本隱私權政策規範您的個人和非個人資訊的收集、處理和使用 
				作為「刪除背景」的用戶，自標題中顯示的生效日期起。
				為了處理您的個人數據，刪除背景遵守當前的當地和歐洲立法， 
				及其實施細則。</p>


			<h3>2。收集的資訊</h3>
			<p>無需提供任何資訊即可訪問我們的網站，但需要註冊和/ 
				或簽訂我們的計劃，您需要向我們提供一些個人資訊。資訊（個人 
				服務收集的資訊或非個人資訊可能會因此而有所不同。
				服務收集的個人和非個人資訊將透過三種方式提供給我們：1) 
				自動收集 2) 您自願向我們提供的資訊以及 3) 由第三方提供的資訊。</p>

			<h5>2.1。自動收集的</h5>
			<p>此資訊將包括：</p>
			<ul>
				<li>透過 Cookie 或儲存在您裝置上的類似機制收集的信息，並始終徵得您的同意或在 
					符合其他法律依據。請查看我們的 Cookie 政策以了解更多資訊。</li>
				<li>進行連線的 IP、使用的裝置類型及其特性、版本 
					作業系統、瀏覽器類型、語言、日期、國家/地區、請求時間、 
					您來自的網址、您前往的網址或所使用的行動網路等。</li>
				<li>服務使用資料以及在使用過程中偵測到的可能錯誤。</li>
				<li>此外，「刪除背景」還使用 Google Analytics，這是由 Google, LLC 提供的分析服務。 
					註冊地在美國，總部位於 1600 Amphitheatre Parkway, Mountain View, California 94043。 
					為了提供這些服務，他們使用 cookie 來收集信息，包括使用者的 IP 位址、 
					這些資訊將由 Google 根據 www.google.com 網路上製定的條款進行傳輸、處理和儲存。 
					包括出於法律要求或原因可能將所述資訊傳輸給第三方 
					當所述第三方代表 Google 處理資訊時。</li>
			</ul>
			<p>無論如何，您都可以從<a href="{externalLink:disableGoogleAnalyticsLink}">此處</a>停用 Google Analytics Cookie。</p>

			<h5>2.2。您自願提供的</h5>
			<p>此資訊將包括：</p>
			<ul>
				<li>所有資料均為必填。</li>
				<li>「刪除背景」在網路上完成註冊所需的資訊：姓名、地址和電子郵件等。</li>
				<li>所有資料均為必填。</li>
				<li>用於完成服務簽約的資訊（無論是否為個人資訊），例如您的電子郵件地址以及信用卡或金融卡號。</li>
				<li>透過服務中建立的聯絡或意見管道發送的訊息可能包含的訊息，無論是個人資訊或非個人訊息， 
					例如您的姓名和電子郵件。</li>
			</ul>

			<h5>2.3。第三方提供的</h5>
			<p>此資訊將包括：</p>
			<ul>
				<li>支付系統或信用卡處理機構提供的信息，例如購買時間或金額。</li>
			</ul>


			<h3>3。權利和目的</h3>
			<p>我們通知您，填寫表格是自願的。但是，如果您不填寫必填字段 
				（通常標有星號），將無法或限制使用本服務的某些功能。
				您提供給我們的個人資料將納入「刪除背景」治療活動登記處並進行處理 
				為了能夠滿足您的要求，提供所要求的服務並讓您了解與活動相關的事宜 
				公司及其服務的簡介。
				您可以隨時行使存取、更正、刪除、限制您的治療的權利， 
				透過發送電子郵件至：{supportLink} 或郵寄地址：反對並轉移您的個人數據 
				AV。 Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, 巴塞隆納, 西班牙。
				在這兩種情況下，您都必須提供您的姓名以及您的 DNI 或國民身分證的副本（如有必要）。
				如果您出於特定目的授予同意，您有權隨時撤回同意， 
				不影響基於撤回同意之前的治療的合法性。
				此外，如果您認為「刪除背景」處理資料的方式有問題， 
				您可以將投訴提交給相應的<a href="{knowYourRightsLink}">資料保護機構</a>，即<a href="{aepdLink}">西班牙資料保護機構</a> 
				西班牙的案例中指出了這一點。</p>


			<h3>4。年齡</h3>
			<p>關於使用線上服務，您聲明您已達到法定年齡並且擁有必要的合法權利 
				有能力受本協議約束並按照其條款和條件使用本網站，您完全同意 
				理解並承認。
				您聲明您在使用服務之前和使用期間提供的用於存取服務的所有資訊都是真實、完整的 
				且準確。</p>


			<h3>5。數據的使用</h3>
			<p>刪除後台將使用收集的資料來：</p>
			<ul>
				<li>管理和更新服務（法律依據是我們維護和保留服務的合法權益 
					最新且狀況良好）。</li>
				<li>解決您提出的問題（法律依據是我們處理請求的合法利益並 
					我們的用戶的疑問）。</li>
				<li>處理您的付款（合約為法律依據）。</li>
				<li>提供合約規定的服務（合約為法律依據）。</li>
				<li>維護服務的安全、調查非法活動、執行我們的條款及條件、
					幫助國家安全部隊進行可能的調查（法律依據是我們的 
					保證和維護服務及其使用者安全的合法權益）。</li>
			</ul>
			<p>刪除後台不使用自動決策，儘管它可以產生基本的使用者設定文件， 
				法律依據是我們出於商業目的和提供個人化優惠的合法利益。
				此外，刪除背景可能會以匯總和匿名資料的形式使用用戶信息，以將其顯示給第三方。 
				您也可以與第三方分享有關使用者及其對服務的使用情況的統計資料和人口統計資訊。 
				但這些都不允許這些第三方識別您的個人身分。</p>

			<h5>5.1。在電子郵件和聯絡表單中</h5>
			<p>網站採用 SSL 加密，讓使用者可以透過標準聯絡表單安全地發送其個人資料。
				收集的個人資料將經過自動處理並納入相應的文件中 
				處理活動記錄的記錄，Remove Background 是該記錄的擁有者。</p>
			<p>從這個意義上來說：</p>
			<ul>
				<li>我們將收到您的 IP 位址，該位址將用於驗證訊息的來源，以便為您提供足夠的信息 
					建議（例如，以正確的語言呈現資訊）並檢測可能的違規行為 
					（例如，可能嘗試對服務進行網路攻擊），以及與您的 ISP 相關的資料。</li>
				<li>同樣，您可以透過電話、電子郵件和其他指定的通訊方式向我們提供您的資料。</li>
			</ul>
			<p>關於所使用的付款方式：</p>
			<ul>
				<li>我們的支付服務提供者使用信用卡或金融卡來支付我們提供的服務的費用。 
					服務或其工作人員在任何時候都無法存取銀行詳細資料（例如信用卡號） 
					用戶作為客戶將提供給這些第三方。</li>
			</ul>


			<h3>6。資料保留</h3>
			<p>下面指出了服務處理的資料的保留時間：</p>
			<ul>
				<li>分類資料將被保留，沒有刪除期限。</li>
				<li>
					客戶資料將保留最低限度，並可能保留至：
					<ul>
						<li>依藝術規定，5 年。 1964 年《民法典》（無特殊用語的個人行為）。</li>
						<li>依藝術規定，6 年。 《商法典》第 30 條（例如會計帳簿或發票）。</li>
					</ul>
				</li>
				<li>用戶資料最多將保留 12 個月，以便滿足他們的請求。</li>
			</ul>


			<h3>7。與第三方共享的資料</h3>
			<p>有第三方管理部分服務。
				刪除背景要求他們除了擁有自己的隱私權政策外，還必須遵守本隱私權政策（如適用）。但是，刪除背景將不負責遵守上述政策。
				在某些情況下，刪除背景可能會與第三方分享、使用或保留所收集的任何個人資訊：</p>
			<ul>
				<li>提供服務：</li>
			</ul>
			<p>代表我們履行職能的服務供應商，例如支付服務、網站寄存、業務分析、客戶服務或網路行銷。這些服務提供者可能會收集並存取其履行職能所需的信息，但不得出於任何其他目的共享或使用該資訊。</p>
			<ul>
				<li>與主管機關合作：</li>
			</ul>
			<p>如果我們認為滿足任何法律、法律程序或合法利益是合理必要的。無論如何，我們只會提供嚴格要求的資訊。</p>


			<h3>8。安全措施</h3>
			<p>刪除背景採取所有必要的技術和組織措施
				保護所收集的個人和非個人資訊的安全性和完整性。 
				既防止未經授權的訪問，也防止其意外更改、遺失或破壞。
				無論如何，RemoveBackground不能保證所收集資訊的絕對安全， 
				因此，您必須始終協作並使用有關共享資訊的常識。
				您瞭解並承認，即使刪除後，個人和非個人資訊也可能會被刪除。 
				在快取中或其他使用者複製或儲存它時仍然可見。</p>


			<h3>9。隱私權政策的變更</h3>
			<p>我們未來可能會更新本隱私權政策。我們將透過向您提供的電子郵件地址發送通知和/或在我們網站的顯著位置放置通知來通知您其變更。</p>


			<h3>10。聯絡方式</h3>
			<p>如果您對此隱私權政策有疑問，請透過以下方式與我們聯絡：</p>
			<p>電子郵件：{supportLink}<br> 
				地址：Av. Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, 巴塞隆納, 西班牙。</p>
		`
	},
	gdpr: {
		lastUpdate: '最後更新時間：2024 年 6 月 10 日',
		content: `
			<h3>1。誰負責以及如何聯絡他們？</h3>
			<p>網站的控制者是Remove Background S.L，位址為Av。 Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, 巴塞隆納, 西班牙。</p>
			<p>您可以透過電子郵件聯絡他：{supportLink}。</p>

			<h3>2。收集哪些數據？</h3>
			<p>
				我們透過載入到您裝置上的 cookie 自動收集數據，包括分析數據。 
				我們也收集進行連接的 IP、使用的設備類型及其特徵， 
				作業系統版本、瀏覽器類型、語言、日期、國家/地區、請求時間、 
				您來自的 URL、您前往的 URL 或使用的行動網路等等。
				用戶自願向我們提供一些信息，例如姓名、電子郵件或銀行信息 
				以便能夠聯絡我們、註冊服務或購買訂閱。
			</p>

			<h3>3。收集的資料有何用途？</h3>
			<p>
				除此之外，服務將使用收集的資料來管理和更新服務、回應您的請求、 
				透過電子郵件向您發送我們的電子報和促銷優惠，管理您在平台上的註冊，管理和提供 
				與您的訂閱相關的服務，處理您的付款並開立相應的發票， 
				維護服務的安全、調查非法活動、執行我們的條款和條件以及 
				幫助國家安全部隊和機構進行最終調查。
			</p>

			<h3>4。它們保存多久？</h3>
			<ul>
				<li>分類資料將被保留，沒有刪除期限。</li>
				<li>
					客戶資料將保留最低限度，並可能保留至：
					<ul>
						<li>依藝術規定，5 年。 1964 年《民法典》（無特殊用語的個人行為）。</li>
						<li>依藝術規定，6 年。 《商法典》第 30 條（例如會計帳簿或發票）。</li>
					</ul>
				</li>
				<li>使用者資料的保存期限最長為 12 個月，以便滿足他們的請求。</li>
				<li>從用戶表示同意的那一刻起，我們將一直保留透過服務上傳到社交網路頁面和個人資料的用戶數據，直到他撤回同意為止。</li>
			</ul>

			<h3>5。作為用戶，您有哪些權利？</h3>

			<p>
				存取權：受影響方有權獲得資料控制者的確認 
				或不處理有關他或她的個人資料。
			</p>
			<p>
				修正權：受影響方有權立即從資料控制者取得 
				糾正不準確且直接影響他的個人資料。同樣，有興趣的一方將 
				有權補充不完整的個人數據，包括透過附加聲明的方式。
			</p>
			<p>
				刪除權：受影響方有權立即從資料控制者取得刪除訊息 
				與他有關的個人資料。
			</p>
			<p>
				限制資料處理的權利：包括獲得負責人對您的資料處理的限制， 
				儘管其行使有兩個面向：1) 當您質疑個人資料的準確性時，在允許的時間內 
				負責人進行核實，並且 2) 當您反對處理您的個人資料時，負責人 
				出於合法利益或公共利益的使命而進行，而負責人則核實這些理由是否 
				勝過你的。
			</p>
			<p>
				資料可攜權：受影響方有權接收與其相關的個人數據， 
				他以通用和機械讀取的結構化格式提供給資料控制者，並且 
				將它們傳送給另一個控制者，而不會被提供給它們的控制者阻止。
			</p>
			<p>
				從這個意義上說，利害關係人將有權直接從控制者傳輸個人數據 
				在技術上可行的情況下發送給控制器。
			</p>

			<h3>6。您如何行使您的權利？</h3>

			<p>
				您可以隨時透過電子郵件至：{supportLink} 或郵寄地址來行使您的個人資料權利： 
				AV。 Cerdanyola, 75 - 1°, CP 08172, Sant Cugat del Vallés, 巴塞隆納, 西班牙。在這兩種情況下，您都必須用您的姓名來表明自己的身份， 
				如有必要，還需提供您的 DNI 或國民身分證的副本。
				此外，如果您認為刪除後台處理您資料的方式有問題，您可以直接提出索賠 
				對應的<a href="{knowYourRightsLink}">資料保護機構</a>，即<a href="{aepdLink}">西班牙資料保護機構</a> 
				西班牙的案例中指出了這一點。
			</p>

			<h3>7。是否採取安全措施？</h3>
			<p>
				該服務採取一切必要的技術和組織措施來保護個人的安全和完整性 
				以及收集的非個人資訊。既防止未經授權的訪問，也防止意外更改、遺失或破壞。
				無論如何，本服務無法保證所收集資訊的絕對安全，因此您必須配合並 
				關於共享信息，始終運用常識。
				您瞭解並承認，即使刪除後，個人和非個人資訊仍可能在快取或 
				如果被其他使用者複製或儲存。
			</p>

			<h3>8。是否存在個人資料傳輸或國際傳輸？</h3>

			<p>
				我們不傳輸資料或國際傳輸。但是，有第三方管理部分服務 
				我們要求遵守適用於他們的隱私權政策，並且他們有自己的隱私權政策。 
				這些第三方是代表我們履行職能的服務供應商，例如網站託管、 
				分析監控或網路開發。
				此外，如果我們認為滿足任何法律、法律程序或合法利益是合理必要的。 
				無論如何，我們只會提供嚴格要求的資訊。
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: '最後更新時間：2024 年 6 月 21 日',
		content: `
			<h3>摘要</h3>
			<ul>
			    <li>使用的 Cookie：<strong>自有和第三方</strong></li>
			    <li>它們用於獲取統計數據嗎？ <strong>是的，基於我們更好地管理服務的合法利益。</li>
			    <li>透過此網站安裝 Cookie 的第三方服務：<strong>Google、Google Analytics、Cloudflare 和 Stripe。</li>
			</ul>

			<h3>如何設定和停用cookie</h3>
			<p>
			    您可以透過網頁瀏覽器允許、封鎖或刪除裝置上安裝的 cookie。如果您不允許在您的裝置上安裝 cookie， 
			    瀏覽體驗可能會變差。您可以在下面了解如何在每個瀏覽器中設定 cookie：
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">邊緣</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google瀏覽器</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari 行動版</a></li>
			</ul>

			<h3>1。類型和用途</h3>
			<p>該服務使用自己和第三方的 cookie 來改善瀏覽、提供服務並取得網站使用情況的統計資料。</p>

			<h3>2。什麼是 cookie 以及它的用途是什麼？</h3>
			<p>
			    Cookie 是發送到您的電腦、手機或平板電腦網路瀏覽器的文字文件，用於儲存和檢索以下內容的資訊：
			    瀏覽完成。例如，記住您的使用者名稱和密碼或您的個人資料首選項。
			</p>

			<h3>3。有哪些類型的 cookie？</h3>
			<p>根據管理人員：</p>
			<ul>
			    <li>自己的cookie；它們從我們自己的裝置或網域傳送到您的瀏覽器。</li>
			    <li>第三方 cookie；它們是從我們不直接管理的裝置或網路網域發送到您的瀏覽器的，而是由第三方實體（例如 Google）發送的。</li>
			</ul>
			<p>根據它們保持活躍的時間，有：</p>
			<ul>
			    <li>會話cookie；它們會保留在您瀏覽器的 Cookie 檔案中，直到您離開網站為止，因此不會保留在您的裝置上。</li>
			    <li>持久性cookie；它們保留在您的裝置上，每次您進行新造訪時，我們的網站都會讀取它們。這些 cookie 在特定日期後停止運作。</li>
			</ul>
			<p>最後，根據他們的目的，我們有：</p>
			<ul>
			    <li>技術cookie；它們改善了網站的瀏覽和正常運作。</li>
			    <li>個人化 cookie；它們允許基於一系列標準存取具有預定義特徵的服務。</li>
			    <li>分析 cookie；它們允許測量和統計分析所提供服務的使用情況。</li>
			</ul>
			<p><strong>remove-background.com</strong> 使用的第三方 Cookie 清單</p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>：他們的 Cookie（NID 或 CONSENT）允許個人化廣告在 Google 之外的顯示方式或儲存訊息
			        例如顯示搜尋結果時的首選語言。
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>：其 Cookie（例如 _ga）可以計算使用者造訪網站的次數、方式、時間和地點。
			        無論如何，您都可以從<a href="{externalLink:disableGoogleAnalytics}">此處</a>停用 Google Analytics Cookie。
			    </li>
			    <li>Cloudflare：若要了解 Cloudflare 的 Cookie 政策和使用情況，請點選<a href="{externalLink: cloudflareCookiesPolicy}">此連結</a>。</li>
			    <li>Stripe：在<a href="{externalLink: stripeCookiesPolicy}">此處</a>找到有關 Stripe Cookie 政策和使用情況的資訊。</li>
			</ul>
			
		`
	}
};
